import { Alert } from '@mui/material'
import { format } from 'date-fns'

import { NEGOTIATION_OVERVIEW_RELIABLE_FROM_DATE } from 'components/reports/Metrics/constants/NegotiationOverview'
import { useGetBidNegotiationReliableFromDateQuery } from 'generated/graphql'

interface Props {
  start: Date | null
}

export const NegotiationOverviewHistoryNote = ({ start }: Props) => {
  const { data } = useGetBidNegotiationReliableFromDateQuery()

  const configured = data?.bidNegotiationReliableFromDate
  const reliableFrom = configured ? new Date(configured) : NEGOTIATION_OVERVIEW_RELIABLE_FROM_DATE

  if (start == null || start >= reliableFrom) {
    return null
  }

  const reliableFromMonth = format(reliableFrom, 'MMMM yyyy')

  return (
    <Alert severity='info'>
      {`Original bid prices were not recorded before ${reliableFromMonth}, so jobs posted ` +
        'before then all read as never negotiated. Negotiation figures for periods reaching ' +
        'back beyond that point will appear lower than they actually were.'}
    </Alert>
  )
}
